export default __webpack_public_path__ + "static/media/master.88f4cc2b.svg";